export enum CartValidationState {
  VALID,
  UNFULFILLABLE_CART,
  CART_NOT_FOUND,
  ERROR,
  UNABLE_TO_VERIFY_STOCK
}
